import React, { useEffect, useState } from 'react';
import { navigate } from 'gatsby';
import {
  Content,
  Container,
  ActionIcon,
  Logo,
} from '../../../pages/register/styles';
import Button from '../../Button';
import { BgImage } from '../../Sections/InfoSection/styles';

const RegisterSuccess: React.FC = () => {
  const [time, setTime] = useState(5);

  const navigateToHome = () => navigate('/');

  useEffect(() => {
    if (time > 0) {
      setTimeout(() => {
        setTime(time - 1);
      }, 1000);
    } else {
      navigateToHome();
    }
  }, [time]);

  return (
    <>
      <BgImage image="img/signup-bg.svg" right="0px" top="0px" width={203} height={50} />
      <BgImage image="img/signup-bg7.svg" left="0px" top="0px" width={130} height={130} showOnMobile />
      <BgImage image="img/signup-bg3.svg" right={77} top={150} width={49} height={48} />
      <BgImage image="img/signup-bg5.svg" right="0px" bottom="0px" width={131} height={130} />
      <BgImage image="img/signup-bg2.svg" right={130} bottom={160} width={114} height={80} />
      <BgImage image="img/signup-bg6.svg" left="0px" bottom="0px" width={283} height={97} />
      <BgImage image="img/signup-bg4.svg" left={119} bottom={153} width={204} height={165} />

      <Content>
        <Container>
          <Logo src={`img/logo-allya.svg`} alt="allya" />
          <ActionIcon src={`img/check-circle.svg`} alt="allya" />
          <h1>Cadastro iniciado com sucesso!</h1>
          <h2>
            Você será direcionado para outra página em {time} {time === 1 ? 'segundo' : 'segundos'}. Se não acontecer, por
            favor, clique no botão abaixo:
          </h2>

          <Button
            onClick={navigateToHome}
            title="Continuar"
            width={324}
            classType="big fat orange center"
            type="button"
          />
        </Container>
      </Content>
    </>
  );
};

export default RegisterSuccess;
